import { render, staticRenderFns } from "./LangPicker.vue?vue&type=template&id=42f5fac4&"
import script from "./LangPicker.vue?vue&type=script&lang=js&"
export * from "./LangPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports